{
    "Profile_SupernovaCommercial_LossPayees.lossPayeesInfo": "FR: Loss Payees Info",
    "Profile_SupernovaCommercial_LossPayees.details": "FR: Details",
    "Profile_SupernovaCommercial_LossPayees.haveAnyLossPayees": "FR: Do you have any Loss Payees?",
    "Profile_SupernovaCommercial_LossPayees.lossPayees": "FR: Loss Payees"
}
